import * as React from 'react';
import PropTypes from "prop-types";
import { Player, BigPlayButton } from 'video-react';

import styles from './style.css';

class StickersComponentsMediaVideo extends React.PureComponent {

  static defaultProps = {
    minVideoHeight: 200
  };

  static propTypes = {
    minVideoHeight: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = {
      videoHeight: null,
      videoWidth: null,
    };
  }

  handleStateChange(state, prevState) {
    const width = state.videoWidth;
    const height = state.videoHeight;

    let videoHeight = '30vh';
    let videoWidth = videoHeight * width / height;
    if (videoHeight < this.props.minVideoHeight) {
      videoHeight = this.props.minVideoHeight;
      videoWidth = videoHeight * width / height;
    }

    this.setState({
      videoHeight,
      videoWidth
    });
  }

  onVideoRef = (videoRef) => {
    this.videoRef = videoRef;
    this.videoRef && this.videoRef.subscribeToStateChange(this.handleStateChange.bind(this));
  };

  render() {
    return (
      <div className={styles.container}>
        <Player
          className={styles.video}
          ref={this.onVideoRef}
          height={this.state.videoHeight}
          width={this.state.videoWidth}
          playsInline
          fluid={false}
          src={this.props.source}
          poster={this.props.thumbnail}>
          <BigPlayButton position="center" />
        </Player>
        { this.props.thumbnail && (
          <div style={{ backgroundImage: `url(${this.props.thumbnail})` }} className={styles.imgBg}/>
        ) }
      </div>
    )
  }
}

export default StickersComponentsMediaVideo;